import {prepareChildren} from "./util";
import {VNode} from "./vnode";
// import {NODETYPE} from "./nodetype"
import {isStr} from "../core";
import {View} from "./view";

export function render(node, rootView = View.create('anonymous', {render:()=>node})) {
    if (isStr(node)) return VNode.createText(node)
    if (node.isView) {
        return renderView(node, rootView)
    }
    if (node instanceof Function) {
        return render(node(), rootView)
    }
    node.$root = rootView
    if (node.nodes) {
        node.nodes=node.nodes.map((n)=>{
            return render(n, rootView)
        })
    }
    return node
}

export function renderView(view, rootView = view) {
    try {
        let rendered = view.render.call(view, view.props)
        view.$node = rendered
        view.$root = view === rootView?undefined:rootView
        if (view.onCreate) view.onCreate.call(view)
        if (rendered.isView) return renderView(rendered)
        // set component as fragment
        if (rendered.isFrag) view.isFrag = true
        rendered.$root = rootView
        if (rendered.nodes) {
            rendered.nodes = prepareChildren(rendered.nodes, render, rootView)
        }
        return view
    } catch (e) {
        console.log(view, e)
    }

}